import moment from 'moment'
import React from 'react'

import {
  A,
  Avatar,
  Div,
  IconButton,
  Input,
  Span,
  ToolTip 
} from '@driftt/tide-core'
import { resolveContactName } from 'utils/contact'

const SelectCell = ({ id }, onSelect, isSelected) => {
  return (
    <Input type="checkbox" checked={isSelected}
      onChange={(event) => onSelect(id, event)} />
  )
}

const NameCell = (contact) => {
  return (
    <Div className="contact-name-cell">
      <Avatar user={contact} type="user"/>
      <Div className="contact-name">
        <Span>
          <A href={`/contacts/details/${contact.id}`} target="_blank">
            <Div className="contact-name-cell--inner">
              {resolveContactName(contact, true)}
            </Div>
          </A>
        </Span>
      </Div>
    </Div>
  )
}

const ActionsCell = (contact, onDelete, onViewDetail) => {
  return (
    <Div className="contact-actions-cell">
      <Div className="contact-actions-button contact-actions-view-details" onClick={() => onViewDetail(contact.id)}>
        <ToolTip flow="up" component={`View details`}>
          <IconButton icon="user-profile-2" size="large"
            inline={true} inlineStyle="subtle" />
        </ToolTip>
      </Div>
      <Div className="contact-actions-button contact-actions-delete" onClick={() => onDelete(contact.id)}>
        <ToolTip flow="up" component={"Delete contact"}>
          <IconButton icon="trash" size="large"
            inline={true} inlineStyle="subtle" />
        </ToolTip>
      </Div>
    </Div>
  )
}

const EmailCell = ({ email }) =>
  <Div>
    <ToolTip flow="up" component={email ? email : 'Unknown'}>
      <Div className="contact-email-cell">
        {email ? email : 'Unknown'}
      </Div>
    </ToolTip>
  </Div>

const LeadStageCell = ({ attributes: { _classification } }) => _classification ? <Div>{_classification}</Div> : <Span>&mdash;</Span>

const LastContactedCell = ({ attributes: { last_contacted } }) => (
  last_contacted ? <Div>{moment(last_contacted).fromNow()}</Div> : <Span>&mdash;</Span>
)

export const RowFormatter = (
  contact, onDelete, onViewDetail, onSelect, selectedContacts
) => {
  return {
    data: [
      { content: SelectCell(contact, onSelect, (selectedContacts && selectedContacts.includes(contact.id))) },
      { content: NameCell(contact) },
      { content: EmailCell(contact) },
      { content: LeadStageCell(contact) },
      { content: LastContactedCell(contact) },
      {
        content: ActionsCell(contact, onDelete, onViewDetail),
        className: 'actions-cell' 
      },
    ]
  }
}
